import { useState } from "react";
import { SupportRequestDto } from "@/types/support";
import { supportService } from "@/services/supportService";

export function useSupport() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<boolean>(false);

  async function sendSupportRequest(data: SupportRequestDto) {
    setLoading(true);
    setError(null);
    setSuccess(false);
    try {
      await supportService.createSupportRequest(data);
      setSuccess(true);
    } catch (err: any) {
      setError(
        err?.response?.data?.message || "Failed to send support request"
      );
    } finally {
      setLoading(false);
    }
  }

  // Reset functions to prevent infinite update loops
  const resetSuccess = () => setSuccess(false);
  const resetError = () => setError(null);

  return {
    sendSupportRequest,
    loading,
    error,
    success,
    resetSuccess,
    resetError,
  };
}
